module.exports = __webpack_public_path__ + "img/Mapi.d0db00a7.svg";